import Vue from "vue";
import Vuex from "vuex";
import UAParser from "ua-parser-js";
import statics from "./statics";
import userInfo from "./userInfo";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    Parser: UAParser(),
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    statics,
    userInfo,
  },
});
